<template>
  <div class="wrapper">
    <div v-if="institution !== undefined" class="" style="margin:-5%;">
      <parallax
        class="page-header header-filter header-small"
        parallax-active="true"
        :style="headerStyle"
        :title="credit_picture"
      >
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h1 class="title">
                <img
                  style="max-height: 35vh; max-width: 50%"
                  class="md-toolbar-section-center"
                  :src="
                    `${IREALCONFIG.static_ressources}/institutes/${institution.institution}_LOGO.png`
                  "
                />
              </h1>
            </div>
          </div>
        </div>
      </parallax>
      <div class="main main-raised">
        <div class="section section-about-description text-center pb-0">
          <div class="container">
            <h1 class="title">
              {{ institution.name }}
            </h1>
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <h2 class="title">About us</h2>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
                <h5
                  class="description"
                  v-for="d in institution.description"
                  :key="d"
                  v-html="d"
                >
                  {{ d }}
                </h5>
                <p class="text-justify pl-3 pr-3">
                  website:
                  <a :href="`${institution.url_web}`" target="_blank">{{
                    institution.url_web
                  }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div
            v-if="experiences.length > 0"
            class="section section-about-office pb-0"
          >
            <div class="container">
              <div class="md-layout text-center">
                <div
                  class="md-layout-item md-size-66 md-small-size-100 mx-auto"
                >
                  <h2 class="title">Our experiments</h2>
                </div>
              </div>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                  v-for="e of experiences"
                  :key="e.id"
                >
                  <ExperienceCard :e="e"></ExperienceCard>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="section section-about-office pb-0">
           </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// The Root component for viewing informations on IREAL experiment

// @ is an alias to /src
import IrealVue from "ireal-vue";
import ExperienceCard from "@/components/ExperienceCard.vue";
import Parallax from "vue-material-kit-pro/src/components/Parallax.vue";

export default {
  name: "institution-detail",
  props: ["id"],
  components: { ExperienceCard, Parallax },
  bodyClass: "about-us",
  mixins: [IrealVue.httpMixin],
  data() {
    return {
      institution: [],
      experiences: [],
      description: "",
      image: null
    };
  },
  mounted() {
    this.load();
  },
  filters: {
    truncate: function(value, limit) {
      if (value.length > limit) {
        value = value.substring(0, limit - 3) + "...";
      }
      return value;
    }
  },
  methods: {
    async load() {
      this.institution = await this.getObject("institution", this.id);
      this.institution.description = this.institution.description.split("***");
      this.institution.description.forEach(sentence => {
        this.description = this.description + "<br>" + sentence;

        return this.description;
      });
      this.experiences = await this.getObjectList(
        "experience/experience_by_institution",
        { institution: this.institution.id }
      );
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.IREALCONFIG.static_ressources}/institutes/${this.institution.institution}_CAMPUS.jpg)`
      };
    },
    credit_picture() {
      return this.institution.image_campus != "none"
        ? this.institution.image_campus
        : "";
    }
  }
};
</script>
<style scoped>
.header-filter::before {
  background: rgba(0, 0, 0, 0.2);
}
</style>
